import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './organisation.reducer';

export const OrganisationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const organisationEntity = useAppSelector(state => state.organisation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="organisationDetailsHeading">
          <Translate contentKey="crawlerBackendApp.organisation.detail.title">Organisation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{organisationEntity.id}</dd>
          <dt>
            <span id="organisationId">
              <Translate contentKey="crawlerBackendApp.organisation.organisationId">Organisation Id</Translate>
            </span>
          </dt>
          <dd>{organisationEntity.organisationId}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="crawlerBackendApp.organisation.name">Name</Translate>
            </span>
          </dt>
          <dd>{organisationEntity.name}</dd>
          <dt>
            <span id="vatId">
              <Translate contentKey="crawlerBackendApp.organisation.vatId">Vat Id</Translate>
            </span>
          </dt>
          <dd>{organisationEntity.vatId}</dd>
          <dt>
            <span id="organizationType">
              <Translate contentKey="crawlerBackendApp.organisation.organizationType">Organization Type</Translate>
            </span>
          </dt>
          <dd>{organisationEntity.organizationType}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="crawlerBackendApp.organisation.status">Status</Translate>
            </span>
          </dt>
          <dd>{organisationEntity.status ? 'true' : 'false'}</dd>
          <dt>
            <span id="enterpriseSize">
              <Translate contentKey="crawlerBackendApp.organisation.enterpriseSize">Enterprise Size</Translate>
            </span>
          </dt>
          <dd>{organisationEntity.enterpriseSize}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.organisation.customerAccount">Customer Account</Translate>
          </dt>
          <dd>{organisationEntity.customerAccount ? organisationEntity.customerAccount.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.organisation.parentOrganisation">Parent Organisation</Translate>
          </dt>
          <dd>{organisationEntity.parentOrganisation ? organisationEntity.parentOrganisation.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.organisation.organisationAddress">Organisation Address</Translate>
          </dt>
          <dd>{organisationEntity.organisationAddress ? organisationEntity.organisationAddress.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.organisation.contact">Contact</Translate>
          </dt>
          <dd>{organisationEntity.contact ? organisationEntity.contact.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/organisation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/organisation/${organisationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OrganisationDetail;
